import { ref } from "vue";

export const vuexForm = ref({})